import styled from 'styled-components'
import { tokens } from 'styling/tokens'

export {
  SectionLabel,
  SectionCount,
  CampList,
  CampCard,
  CampHeader,
  CampIdentity,
  CampName,
  CampMeta,
  CampKpis,
  CampKpi,
  CampKpiValue,
  CampKpiLabel,
  ChevronBox,
  CampCollapse,
  CampCollapseInner,
} from './AccommodationCamp.styled'

export const StatBand = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: ${tokens.space.sm};
  margin-bottom: 1.25rem;

  @media (max-width: 1180px) {
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 680px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const BlockList = styled.div`
  border-top: 1px solid ${tokens.border.hairline};
  padding: 0.25rem 1rem 0.375rem;
`

export const BlockRow = styled.div`
  display: grid;
  grid-template-columns: minmax(9rem, 1.1fr) minmax(7rem, 1.5fr) auto;
  align-items: center;
  gap: 1.5rem;
  padding: 0.625rem 0;
  border-bottom: 1px solid ${tokens.border.hairline};

  &:last-child {
    border-bottom: none;
  }

  @media (max-width: 760px) {
    grid-template-columns: 1fr;
    gap: 0.625rem;
  }
`

export const BlockIdentity = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.1rem;
  min-width: 0;
`

export const BlockName = styled.div`
  font-size: ${tokens.font.body};
  font-weight: 500;
  color: ${tokens.text.primary};
`

export const BlockMeta = styled.div`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const BlockBar = styled.div`
  display: flex;
  align-items: center;
  gap: 0.625rem;
`

export const BlockBarValue = styled.span`
  width: 2.5rem;
  text-align: right;
  font-size: ${tokens.font.label};
  font-weight: 600;
  color: ${tokens.text.secondary};
  font-variant-numeric: tabular-nums;
`

export const CountGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 1.15rem;
  flex: none;

  @media (max-width: 760px) {
    justify-content: flex-start;
    gap: 1.25rem;
  }
`

export const CountChip = styled.div`
  display: flex;
  align-items: center;
  gap: 0.4rem;
`

export const CountDot = styled.span<{ $color: string }>`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 2px;
  flex: none;
  background: ${(props) => props.$color};
`

export const CountValue = styled.span<{ $dim?: boolean }>`
  font-size: ${tokens.font.body};
  font-weight: 600;
  color: ${(props) => (props.$dim ? tokens.text.muted : tokens.text.primary)};
  font-variant-numeric: tabular-nums;
`

export const CountLabel = styled.span`
  font-size: ${tokens.font.micro};
  color: ${tokens.text.muted};
`

export const BlockEmpty = styled.div`
  padding: 0.75rem 0;
  font-size: ${tokens.font.label};
  color: ${tokens.text.muted};
`
